import { render, staticRenderFns } from "./AsientosLiberados.vue?vue&type=template&id=1a732f0e"
import script from "./AsientosLiberados.vue?vue&type=script&setup=true&lang=js"
export * from "./AsientosLiberados.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports